import {
  combineReducers,
  configureStore,
} from "@reduxjs/toolkit";
import { userSlice } from "modules/auth/store";
import { workspaceSlice } from "modules/workspaces/store";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  [userSlice.name]: userSlice.reducer,
  [workspaceSlice.name]: workspaceSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
